import { IPage, registerPage } from '../Components/Page';
import { formatTime, useInitAsync } from '../Utils';
import { useParams } from 'react-router';
import apiClient, { IEventStats, ITicketData } from '../Services/ApiClient';
import { useEffect, useRef, useState } from 'react';
import Home from './Home';
import Field from '../Components/Field';
import { useNetwork } from '../Hooks/Network';
import "./EventMonitor.scss"
import Title from '../Components/Title';
import { EventCheckMode, eventStore, IStoreEvent } from '../Services/EventsStore';
import session from '../Services/Session';
import { Button, Switch, Typography } from '@mui/material';
import { useActions } from '../Hooks/Actions';
import { ReactComponent as StatsIcon } from '../Images/sat.svg';
import { useEventStats } from '../Hooks/EventStatsContext';
import useAppBar from '../Hooks/AppBarContext';
import Settings from './Settings';
import EventList from './EventList';

interface IEventMonitorParams {

    event?: IStoreEvent;
}

interface ITicketDetails {
    filterName: string;
    tickets: ITicketData[];
}

export function EventMonitorContent(props: IEventMonitorParams) {

    const network = useNetwork();

    const [event, setEvent] = useState(props.event);

    const [details, setDetails] = useState({ filterName: null, tickets: [] } as ITicketDetails);

    const showBySector = useRef(false);

    const setAppBar = useAppBar();

    const { eventId } = useParams();

    const actions = useActions();

    const stats = useEventStats(showBySector.current);    

    useEffect(() => {

        setAppBar({
            title: "Access Control",
            actions: [
                {
                    body: Settings.title,
                    icon: Settings.icon,
                    executeAsync: async () => actions.settings()
                },
                {
                    body: EventList.title,
                    icon: EventList.icon,
                    executeAsync: async () => actions.eventList()
                },
              
            ]
        });

    }, [event?.id]);


    const updateDetailsAsync = async (sectorName: string, stat: string) => {

        let data = await network(async () => apiClient.getTicketDataAsync({ eventID: eventId, searchMethod: "ticket_holder", searchString: "" }));

        data = data.filter(a => {

            if (sectorName && a.settore != sectorName)
                return false;

            if (stat == "Attesi" && a.stato.startsWith('Z'))
                return false;

            if (stat == "Entrati" && a.stato.startsWith('V'))
                return false;

            return true;
        });

        const newDetails = {
            filterName: (sectorName ? sectorName + " " : "") + stat,
            tickets: data
        } as ITicketDetails;

        setDetails(newDetails); 
    }

    useInitAsync(() => network(async () => {

        if (!event && eventId) {
            session.activeEvent = await eventStore.getEventByIdAsync(eventId);
            setEvent(session.activeEvent);
        }
    }));


    if (!stats.lastStats || !event)
        return null;

    const createFields = (curStats: IEventStats) => {
        const result = [];
        for (const key in curStats) {
            if (key == "Settore")
                continue;
            result.push(<Field onClick={()=> updateDetailsAsync(curStats.Settore, key)} key={key} label={key}>{curStats[key]}</Field>)
        }

        return result;
    }

    const setShowBySector = (value: boolean) => {
        showBySector.current = value;
        stats.updateAsync(false);
    }

    const formatDateTime = (date: string | number, time: string | number) => {

        if (!date)
            return "";

        date = date.toString();
        time = time.toString();

        return date.substring(6, 8) + "/" +
            date.substring(4, 6) + "/" +
            date.substring(0, 4) + " " +
            time.substring(0, 2) + ":" +
            time.substring(2, 4);
    }

    const lastStats = showBySector.current ? stats.lastStatsBySector : [stats.lastStats]; 

    return <>
        <header>
            <div className="sub-title">Monitor</div>
            <Title>{event?.title}</Title>
        </header>
        <div className="last-update">Aggiornato alle: {formatTime(stats.lastUpdate)}</div>

        <section className="stats">
            {lastStats?.map(a => <div className="stats-group">
                {a?.Settore && <header><Typography>{a.Settore}</Typography></header>} 
                <fieldset>
                    {createFields(a)}
                </fieldset> 
            </div>)}
            <div className="setting-field">
                <label>Mostra per settore</label>
                <Switch checked={showBySector.current} onChange={(el, v) => setShowBySector(v)} />

            </div>
            <div className="actions">
                <Button variant="contained" size="large" onClick={() => stats.updateAsync(true)}>Aggiorna</Button>
                {event?.checkMode === EventCheckMode.Scan && <Button variant="contained" size="large" onClick={() => actions.scanHistory(eventId)}>Cronologia</Button>}
            </div>
        </section>

        {details?.filterName && <section className= "details">
            <header><Typography>{details?.filterName}</Typography></header>
            <ul>
            {details.tickets.map(ticket => <li>

                <fieldset>
                    {ticket.nome.trim().length > 0 && <Field label="Nome">{ticket.nome + " " + ticket.cognome}</Field>}
                    <Field label="Ordine">{ticket.riferimentoordine}</Field>
                    <Field label="Tipo Titolo">{ticket.tipotitolo}</Field>
                    {ticket.dataemissione && <Field label="Data Emissione">{formatDateTime(ticket.dataemissione, ticket.oraemissione)}</Field>}
                    {ticket.dataingressocontrollo && <Field label="Ora Controllo">{formatDateTime(ticket.dataingressocontrollo, ticket.oraingressocontrollo)}</Field>}
                    <Field label="Settore">{ticket.settore}</Field>
                    <Field label="Fila">{ticket.fila}</Field>
                    <Field label="Posto">{ticket.posto}</Field>
                    <Field label="Note Blocco">{ticket.noteblocco}</Field>
                </fieldset>

            </li>)}
            </ul>
        </section>}
 
    </>
}

const EventMonitor: IPage = {

    name: "event-monitor",
    title: "Monitor",
    route: "/monitor/:eventId",
    container: Home,
    icon: <StatsIcon/>,
    appBar: { title: "Access Control", backVisible: true },
    content: <EventMonitorContent />
}

registerPage(EventMonitor);

export default EventMonitor;